import React from "react";
import { LOCALE_STRINGS } from "constants/locales";

const ArrowRightIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="diagram-arrow"
  >
    <path
      d="M1 7H15M15 7L9 1M15 7L9 13"
      stroke="#008CB7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DecisionDiagramSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  const inputList = [
    strings.diagram_input_1 || "Traditional data",
    strings.diagram_input_2 || "Logistics data",
    strings.diagram_input_3 || "Live Trade Data",
  ];

  const outputList = [
    strings.diagram_output_1 || "Approved credit limit",
    strings.diagram_output_2 || "Terms & pricing",
    strings.diagram_output_3 || "Ongoing risk monitoring",
  ];

  return (
    <section className="decision-diagram-wrapper">
      <div className="decision-diagram">
        
        <div className="diagram-group diagram-group--input">
          <span className="diagram-group__label">
            {strings.diagram_label_input || "Input"}
          </span>
          <div className="diagram-chips-stack">
            {inputList.map((text, idx) => (
              <div key={idx} className="diagram-chip">
                <span className="diagram-chip__text">{text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="diagram-arrow-container">
          <ArrowRightIcon />
        </div>

        <div className="diagram-group diagram-group--decision">
          <span className="diagram-group__label">
            {strings.diagram_label_decision || "Decision"}
          </span>
          <div className="decision-engine-hub">
            <span className="decision-engine-hub__text">
              {strings.diagram_engine_text || "Engine"}
            </span>
          </div>
        </div>

        <div className="diagram-arrow-container">
          <ArrowRightIcon />
        </div>

        <div className="diagram-group diagram-group--output">
          <span className="diagram-group__label">
            {strings.diagram_label_output || "Output"}
          </span>
          <div className="diagram-chips-stack">
            {outputList.map((text, idx) => (
              <div key={idx} className="diagram-chip">
                <span className="diagram-chip__text">{text}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};